let isSupportWebpGoal = null;

const isSupportWebp = () => {
    if (isSupportWebpGoal === true) {
        return true;
    }

    if (isSupportWebpGoal === false) {
        return false;
    }

    try {
        const isSupportWebp =
            document.createElement('canvas').toDataURL('image/webp', 0.5).indexOf('data:image/webp') === 0;
        const regexSafari = navigator.userAgent.match(/version\/([\d\.]+).*?safari/i);

        // Safari浏览器版本判断
        if(!isSupportWebp && regexSafari && regexSafari[1]) {
            const isMobile = navigator.userAgent.toLocaleLowerCase().includes('iphone');
            const version = parseInt(regexSafari[1]) || 0;

            if (isMobile && version >= 14) {
                isSupportWebpGoal = true;
    
                return true;
            }

            if(!isMobile && version >= 16) {
                isSupportWebpGoal = true;
    
                return true;
            }
        }

        isSupportWebpGoal = isSupportWebp;

        return isSupportWebp;
    } catch (err) {
        isSupportWebpGoal = false;

        return false;
    }
};

/**
 * 将前面的裁图前缀,参数以及协议头去掉
 * @param {*} url 要清洗的 url
 */
const clear = url => {
    try {
        if (!url) {
            return url;
        }
        if (url.includes('d.ifengimg.com/')) {
            url = url.split('d.ifengimg.com/').pop();
            const paths = url.split('/');

            paths.shift();
            url = paths.join('/');
        }

        if (url.includes('http://')) {
            url = url.substring(7);
        }

        if (url.includes('https://')) {
            url = url.substring(8);
        }

        if (url.includes('//')) {
            url = url.substring(2);
        }

        return url;
    } catch (error) {
        console.error(error);

        return url;
    }
};

const ifengImgDomain = [
    'x0.ifengimg.com',
    'y0.ifengimg.com',
    'y1.ifengimg.com',
    'y2.ifengimg.com',
    'y3.ifengimg.com',
    'm0.ifengimg.com',
    'm1.ifengimg.com',
    'm2.ifengimg.com',
    'm3.ifengimg.com',
    'img.ifeng.com',
    'mimg.ifeng.com',
    's0.mimg.ifeng.com',
    's1.mimg.ifeng.com',
    's2.mimg.ifeng.com',
    's3.mimg.ifeng.com',
    's4.mimg.ifeng.com',
    'a0.ifengimg.com',
    'a1.ifengimg.com',
    'a2.ifengimg.com',
    'a3.ifengimg.com',
    's0.ifengimg.com',
    's1.ifengimg.com',
    's2.ifengimg.com',
    's3.ifengimg.com',
    'res.ent.ifeng.com',
    'res.news.ifeng.com',
    'res.fashion.ifeng.com',
    'blogfile.ifeng.com',
    'entimg.ifeng.com',
    'res.health.ifeng.com',
    'res.book.ifeng.com',
    'imgs.diantai.ifeng.com',
    'img.ugc.ifeng.com',
    'img1.ugc.ifeng.com',
    'res.phtv.ifeng.com',
    'bbsfile.ifeng.com',
    'res.img.ifeng.com',
    'c0.ifengimg.com',
    'c1.ifengimg.com',
    'p0.ifengimg.com',
    'p1.ifengimg.com',
    'p2.ifengimg.com',
    'p3.ifengimg.com',
    'q0.ifengimg.com',
    'p0.iikuzhan.com',
    'yj.fcai.com',
    'my.ifengimg.com',
    'sy.ifeng.com',
    'c0.fengshows.com',
    'c1.fengshows.com',
    'p0.fengshows.com',
    'p1.fengshows.com',
    'p2.fengshows.com',
    'p3.fengshows.com',
    'y0.fengshows.com',
    'y1.fengshows.com',
    'y2.fengshows.com',
    'y3.fengshows.com',
    'e0.ifengimg.com',
    'ugc-img.ifengimg.com',
];

/**
 * 判断域名是否为公司的
 * @param {string} url
 */
const checkDomain = url => {
    try {
        if (!url) {
            return url;
        }
        const domain = url.split('/')[0];

        if (ifengImgDomain.includes(domain)) return true;

        return false;
    } catch (error) {
        console.error(error);

        return false;
    }
};

/**
 * 裁剪图片方法
 * @param {string} url 系统提供的图片地址
 * @param {number} width 图片裁切宽度
 * @param {number} height 图片裁切高度
 * @param {number} quality 图片裁切质量，默认90，最大值100，一般可以不填，不建议写100
 * @param {boolean} isAddWebp 是否添加webp
 */
const formatImage = (url, width, height, quality = 90, isAddWebp) => {
    try {
        if (!url) {
            return url;
        }
        url = clear(url.trim());

        if (!checkDomain(url)) return `//${url}`;

        const params = [];

        if (width) {
            params.push(`w${width}`);
        }

        if (height) {
            params.push(`h${height}`);
        }

        if (quality) {
            params.push(`q${quality}`);
        }

        if (isAddWebp) {
            if (url.includes('.gif')) {
                params.push('ext'); 
            }
            params.push('webp');
        }

        return `//d.ifengimg.com/${params.join('_')}/${clear(url)}`;
    } catch (error) {
        console.error(error);

        return url;
    }
};

/**
 * 裁剪图片方法
 * @param {string} url 系统提供的图片地址
 * @param {number} width 图片裁切宽度
 * @param {number} height 图片裁切高度
 * @param {number} quality 图片裁切质量，默认90，最大值100，一般可以不填，不建议写100
 * @param {boolean} isAddWebp 是否添加webp
 */
const formatImageAblur = (url, width, height, quality = 90, isAddWebp) => {
    try {
        if (!url) {
            return url;
        }
        url = clear(url.trim());

        if (!checkDomain(url)) return `//${url}`;

        const params = [];

        if (width) {
            params.push(`w${width}`);
        }

        if (height) {
            params.push(`h${height}`);
        }
        if (!url.includes('.gif')) {
            params.push('ablur');
        }
        if (quality) {
            params.push(`q${quality}`);
        }

        if (isAddWebp) {
            if (url.includes('.gif')) {
                params.push('ext'); 
            }
            params.push('webp');
        }

        return `//d.ifengimg.com/${params.join('_')}/${clear(url)}`;
    } catch (error) {
        console.error(error);

        return url;
    }
};

/**
 * 自适应宽高裁剪图片方法
 * @param {string} url 系统提供的图片地址
 * @param {number} width 图片裁切宽度
 * @param {number} height 图片裁切高度
 * @param {number} quality 图片裁切质量，默认90，最大值100，一般可以不填，不建议写100
 */
const formatImageAuto = (url, width, height, quality = 90) => {
    try {
        if (!url) {
            return url;
        }
        url = clear(url.trim());

        if (!checkDomain(url)) return `//${url}`;

        const size = url.match(/_w(\d+)_h(\d+)\./);

        if (!size) {
            return formatImage(url, width, height, quality);
        }

        const imageWidth = (size && size[1] && parseInt(size[1])) || 0;
        const imageHeight = (size && size[2] && parseInt(size[2])) || 0;

        if (imageWidth && imageHeight && imageHeight > imageWidth) {
            return formatImageAblur(url, width, height, quality);
        } else {
            return formatImage(url, width, height, quality);
        }
    } catch (error) {
        console.error(error);

        return url;
    }
};

const formatImageWebpAuto = (url, width, height, quality = 90) => {
    try {
        if (!url) {
            return url;
        }
        url = clear(url.trim());

        if (!checkDomain(url)) return `//${url}`;

        const size = url.match(/_w(\d+)_h(\d+)\./);

        if (!size) {
            return formatImage(url, width, height, quality, isSupportWebp());
        }

        const imageWidth = (size && size[1] && parseInt(size[1])) || 0;
        const imageHeight = (size && size[2] && parseInt(size[2])) || 0;

        if (imageWidth && imageHeight && imageHeight > imageWidth) {
            return formatImageAblur(url, width, height, quality, isSupportWebp());
        } else {
            return formatImage(url, width, height, quality, isSupportWebp());
        }
    } catch (error) {
        console.error(error);

        return url;
    }
};

module.exports = { formatImage, formatImageAblur, formatImageAuto, formatImageWebpAuto };
